// extracted by mini-css-extract-plugin
export default {"container":"style_container__A9DiA","pageLogo":"style_pageLogo__eDQN6"};